<pw-view-title>
  {{ 'planning.createTracking.title' | translate }}
</pw-view-title>

<div class="new-tracking-container mw-70">
  <mat-card *ngIf="form && (task$ | async) as task">
    <mat-card-header>
      <mat-card-title>{{ task.TEXT }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form
        class="container"
        [formGroup]="form.get('base')"
        style="padding-top: 24px">
        <ng-container>
          <div
            *ngIf="task.RESMACHINEBOOKING"
            style="
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
              grid-column: auto / span 2;
            ">
            <mat-radio-group
              formControlName="machineTracking"
              (change)="onMachineTrackingChanged($event)">
              <mat-radio-button
                [checked]="!form.get('base.machineTracking').getRawValue()"
                value="false"
              >{{ 'planning.createTracking.employee' | translate }}
              </mat-radio-button>
              <mat-radio-button
                [checked]="form.get('base.machineTracking').getRawValue()"
                value="true"
              >{{ 'planning.createTracking.machine' | translate }}
              </mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="getErrorMessage(form, 'machineTracking')">
              {{ getErrorMessage(form, 'machineTracking') }}
            </mat-error>
          </div>
        </ng-container>

        <mat-form-field [ngClass]="isMobile ? 'expand-mobile': ''">

          <mat-hint>
            {{ 'planning.createTracking.hint' | translate }} 3h 30m / 03:30 /
            3.5
          </mat-hint>
          <input formControlName="workingTime" matInput/>
          <mat-error *ngIf="getErrorMessage(form, 'workingTime')">
            {{ getErrorMessage(form, 'workingTime') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field [ngClass]="isMobile ? 'expand-mobile': ''">
          <mat-label
          >{{ 'planning.createTracking.date' | translate }}
          </mat-label>
          <input formControlName="date" matInput [matDatepicker]="picker"/>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="getErrorMessage(form, 'date')">
            {{ getErrorMessage(form, 'date') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field style="grid-column: auto / span 2">
          <mat-label
          >{{ 'planning.createTracking.comment' | translate }}
          </mat-label>
          <textarea formControlName="description" matInput></textarea>
          <mat-error *ngIf="getErrorMessage(form, 'comment')">
            {{ getErrorMessage(form, 'comment') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="(incidents$ | async)?.length > 0"
          style="grid-column: auto / span 2">
          <mat-label
          >{{ 'planning.createTracking.incident' | translate }}
          </mat-label>
          <mat-select formControlName="incidentId">
            <mat-option
              *ngFor="let inc of incidents$ | async"
              [value]="inc.OBJECT_ID">
              <img class="mat-icon" src="{{inc.ICON_URL}}">
              {{ inc.TEXT }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getErrorMessage(form, 'incidentId')">
            {{ getErrorMessage(form, 'incidentId') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="(users$ | async)?.length > 0 && task.CAN_TRACK_FOR_DIFFERENT_USER"
          style="grid-column: auto / span 2">
          <mat-label
          >{{ 'planning.createTracking.user' | translate }}
          </mat-label>
          <mat-select formControlName="userId" (valueChange)="onUserChanged($event)">
            <mat-option
              *ngFor="let user of users$ | async"
              [value]="user.OBJECT_ID">
              {{ user.TEXT }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getErrorMessage(form, 'userId')">
            {{ getErrorMessage(form, 'userId') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="(task$ | async)?.RES_ID === 0">
          <mat-label
          >{{ 'planning.createTracking.resource' | translate }}
          </mat-label>
          <mat-select formControlName="resId" (valueChange)="onResourceChanged($event)">
            <mat-option [value]="0"></mat-option>
            <mat-option
              *ngFor="let res of res$ | async"
              [value]="res.OBJECT_ID">
              {{ res.TEXT }}

            </mat-option>
          </mat-select>
          <mat-error *ngIf="getErrorMessage(form, 'resId')">
            {{ getErrorMessage(form, 'resId') }}
          </mat-error>
        </mat-form-field>
      </form>

      <p4m-additional-tracking
        [formGroup]="form.get('additional')"
        [ratingTypes]="ratingTypes$ | async"
        [serviceTypes]="serviceTypes$ | async"
        [activities]="activities$ | async"
        [positions]="positions$ | async"
        (ratingTypeChanged)="onRatingTypeChanged($event)">
      </p4m-additional-tracking>
    </mat-card-content>

    <mat-card-actions align="end" style="margin: 8px" *ngIf="form">
      <button
        mat-stroked-button
        color="accent"
        style="margin-right: 12px"
        (click)="createPreliminaryTracking()">
        {{ 'planning.createTracking.addTracking' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-accordion>
    <mat-expansion-panel style="margin-top: 1rem" [expanded]="latestTrackingsExpanded"
                         (expandedChange)="onLatestTrackingsExpandedChanged($event)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Letzte Buchungen
        </mat-panel-title>
        <mat-panel-description>
          <button mat-icon-button (click)="refreshLatestTrackings()">
            <mat-icon>refresh</mat-icon>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p4m-latest-trackings #latestTrackings class="new-tracking-table-wrapper"
                            [userId]="this.form?.get('base.userId').getRawValue()"
                            [trackingDate]="this.form?.get('base.date').getRawValue()"></p4m-latest-trackings>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-expansion-panel
    style="margin-top: 12px"
    expanded="true"
    *ngIf="multiTracking">
    <mat-expansion-panel-header
    >{{ 'planning.createTracking.preliminaryTrackings' | translate }}
    </mat-expansion-panel-header>
    <p4m-multi-tracking-component
      #multiTrackingRef
      [trackingData]="getTrackingData()"
      (preliminaryTrackingsChanged)="onTrackingsChanged($event)">
    </p4m-multi-tracking-component>
  </mat-expansion-panel>

  <div class="p4m-flex-container" style="padding-top: 12px; align-items: end">
    <button
      mat-raised-button
      color="accent"
      [disabled]="!form?.valid"
      (click)="createTrackings()">
      {{ 'planning.createTracking.finish' | translate }}
    </button>
  </div>
</div>



